@if (isTranslationLoaded) {
    <div class="pathway-header">
        <qai-inner-wrap>

        <div class="breadcrumb-container">
            <qai-breadcrumb-list [items]="getBreadcrumbItems()"></qai-breadcrumb-list>
        </div>

        <div class="heading-row">
            <div class="heading-with-image">
             @if (pathwayDetails?.logoUrl) {
                <div class="header-img">
                    <img [src]="pathwayDetails?.logoUrl" />
                </div>
            }
            <span class="pathway-heading">{{ pathwayDetails?.pathwayName }}</span>
            </div>

            <div class="date-container">
            @if (completedAt()) {
                <qai-badge
                    [shape]="'round'"
                    [kind]="'green'"
                    [label]="formattedCompletedAt">
                </qai-badge>
            } @else if (pathwayDetails?.pathwayDueDate) {
                <qai-badge
                    [shape]="'rectangle'"
                    [kind]="'default'"
                    [label]="'learningPathway.DUE_DATE' | transloco"
                    [description]="pathwayDetails?.pathwayDueDate">
                    <qai-glyph positionStart kind="calendar" spotlight="brand" size="32px" />
                </qai-badge>
            }
            </div>
        </div>

        <div class="description-container">
             <span class="pathway-description">
                {{ pathwayDetails?.pathwayDescription }}
            </span>
        </div>

        </qai-inner-wrap>
    </div>
}